import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min';

export default class DisplayNavbar extends Component {
  

  render(){
    
    let signOut;

    if (this.props.loggedIn) {
      signOut = <NavLink role="navigation" onClick={this.props.handleSignOut} className="nav-link top-nav-link" activeClassName="sign-out" to="/home/login">Sign Out</NavLink>;
    } 

    let page;
    if (this.props.loggedIn) {
      page = <NavLink className="nav-link top-nav-link" activeClassName="active"  to="/home">Dashboard</NavLink>;
    } else {
      page = <NavLink className="nav-link top-nav-link" activeClassName="active"  to="/home">Home</NavLink>;
    }

    

    return (
      <header>
          <nav className="navbar navbar-head navbar-expand-lg navbar-light" id="main-nav" role="navigation">
            <div>
              <a href="#main-content" className="skip-link">Skip to main content</a>
            </div>
            <p className="navbar-brand nav-title top-header logo-text">
              <a className="logo" href="/home">
                <span aria-hidden='false'><img className="logo" src={"/img/smile.png"} alt="Know Your Bill logo"></img></span>
              </a> Know Your Bill
            </p>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">   
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item mr-3">
                  {page}
                </li>
                <li className="nav-item mr-3">
                  <NavLink className="nav-link top-nav-link" activeClassName="active" to="/guide">Sustainability Guide</NavLink>
                </li>
              </ul>
              <ul className="navbar-nav ml-auto">
                <li className="nav-item signout-margin">
                  {signOut}
                </li>
              </ul>
            </div>
          </nav>
        </header>
    )
  }
}